import { render, staticRenderFns } from "./UserTestimonial.vue?vue&type=template&id=00ebd704&scoped=true"
import script from "./UserTestimonial.vue?vue&type=script&lang=js"
export * from "./UserTestimonial.vue?vue&type=script&lang=js"
import style0 from "./UserTestimonial.vue?vue&type=style&index=0&id=00ebd704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ebd704",
  null
  
)

/* custom blocks */
import block0 from "./UserTestimonial.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Fcdnjs.cloudflare.com%2Fajax%2Flibs%2Ffont-awesome%2F6.4.0%2Fcss%2Fall.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports